import { ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'

export const SCORE_BREAKDOWN = `
...on scoreBreakdown_Entry {
  id
  typeHandle
  anchorId

  ${ ASSET_MOBILE }
  ${ ASSET_DESKTOP }
  
  headingAdvanced {
    html
  }
  description
  scoreTable {
    score
    heading
    description
  }
}
`